const cpf = (value: string) => {
  if (value.length !== 11) return value

  return `${value.substring(0, 3)}.${value.substring(3, 6)}.${value.substring(6, 9)}-${value.substring(9, 11)}`
}

const phone = (value?: string | null) => {
  if (!value) return ''

  if (value.length < 10) return value

  if (value.length === 11) return `(${value.substring(0, 2)})${value.substring(2, 7)}-${value.substring(7, 11)}`

  return `(${value.substring(0, 2)})${value.substring(2, 6)}-${value.substring(6, 10)}`
}

const date = (value: Date) => {
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(new Date()).replace(',', '')
}

export default { cpf, phone, date }
